import type { Season } from '../types/dashboard';

export const SPORTS = ['Soccer', 'Flag Football', 'Basketball', 'Baseball / T-Ball', 'Volleyball'];
export const PROGRAM_TYPES = ['League', 'Instructional', 'Camp', 'School & Enrichment'];
export const SEASONS: Season[] = ['Spring', 'Summer', 'Fall', 'Winter'];
export const PROGRAM_YEARS = ['2024', '2025', '2026'];

export const SPORT_MIX = [0.36, 0.24, 0.2, 0.14, 0.06];
export const PROGRAM_MIX = [0.62, 0.16, 0.1, 0.12];
export const PROGRAM_PRICE = [189, 129, 219, 99];

export const SPORT_RETENTION_ADJ = [0.03, 0, 0.01, 0.02, -0.03];
export const PROGRAM_RETENTION_ADJ = [0.04, -0.02, -0.08, -0.03];

/** Relative new-member volume by calendar month (Jan … Dec). */
export const MEMBER_SEASONALITY = [0.95, 1.05, 1.25, 0.92, 0.95, 0.8, 0.85, 1.38, 1.0, 0.7, 0.6, 0.55];

export const PARTICIPANT_SEASONALITY: Record<Season, number> = {
  Spring: 1.1,
  Summer: 0.7,
  Fall: 1.2,
  Winter: 0.6,
};
